import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import FormGroup from '../../FormGroup';
import Constructor from '../Constructor/Constructor';
import DynamicSelectSegment from '../../DynamicSelectSegment';
import CustomNotify from "../../Notify";
import { I18nContext } from 'utils/I18n/context';

const ConstructorBanners = (props) => {
    const { t } = useContext(I18nContext);
    const constructorMethods = Constructor(props);
    
    const [state, setState] = useState({
        visible: props.visible,
        banner: props.banner,
        links: props.links,
        goalEntries: props.goalEntries,
        publisherId: props.publisherId,
        offer: props.offer,
        metaParamsmetaParams: {},
        metaParams: {},
        currentLink: {},
        selfieLink: '',
        link: ''
    });

    useEffect(() => {
        const isChangeOffer = state.offer !== props.offer;
        const isChangeBanner = state.banner !== props.banner;
        const isChangeLinks = state.links !== props.links;
        let newState = {
            creativeType: 'banner',
            creativeId: props.banner.id,
            visible: props.visible,
            banner: props.banner,
            links: props.links,
            goalEntries: props.goalEntries,
            offer: props.offer,
            goalEntryId: constructorMethods.getFirstGoal()
        };

        if (isChangeOffer || isChangeBanner || isChangeLinks) {
            newState.selfieLink = '';
            newState.metaParams = {};
            newState.currentLink = props.offer.default_link || (props.links && props.links[0]) || {};
        }

        setState(prev => ({ ...prev, ...newState }));
    }, [props]);

    const onLinkChange = useCallback((item) => {
        setState(prev => ({
            ...prev,
            currentLink: item
        }));
    }, []);

    const getLinkParams = useCallback(() => {
        let linkIdParam = '?l=' + state.currentLink.id,
            selfieLink = state.selfieLink;

        return (selfieLink && state.currentLink.selfie_link) ? linkIdParam + '&sl=' + encodeURIComponent(selfieLink) : linkIdParam;
    }, [state.currentLink, state.selfieLink]);

    const getCode = useCallback(() => {
        return `<a href="${constructorMethods.getResultLink(state.banner)}" title=""><img src="${state.banner.url}" width="${state.banner.width}" height="${state.banner.height}" alt="" /></a>`;
    }, [state.banner, constructorMethods]);

    const setParam = useCallback((e) => {
        if (e.target.value.replace(constructorMethods.getAllowChar(), '') !== e.target.value) {
            constructorMethods.onErrorMsg('notAllowCharMsg');
            return false;
        }

        let metaParams = { ...state.metaParams };
        let banner = { ...state.banner };

        if(typeof banner.params === "string") {
            banner.params = JSON.parse(banner.params);
        }

        if(!state.banner.params) {
            banner['params'] = {};
        }

        metaParams[e.target.placeholder] = e.target.value;
        banner.params[e.target.placeholder] = e.target.value;

        setState(prev => ({
            ...prev,
            metaParams: metaParams,
            banner: banner
        }));
    }, [state, constructorMethods]);

    if (!state.links || !state.links.length) {
        if (state.visible) {
            CustomNotify(t?.constructors?.cantCreateUrlForCreativeNoLinksAvailable || 'Error', 'error');
        }
        return '';
    }

    return (
        <CustomModal
            title={t?.constructors?.createBanner || 'Create Banner'}
            confirmName={t?.constructors?.copy || 'Copy'}
            visible={state.visible}
            onClose={props.onClose}
            bsSize={'sm'}
            onConfirm={constructorMethods.onCopyButtonClick}
        >
            {constructorMethods.renderGoalEntries()}

            <FormGroup
                label={t?.constructors?.link || 'Link'}
            >
                <DynamicSelectSegment
                    segment={'Link'}
                    values={[state.currentLink.id || null]}
                    extraParams={{
                        offer_ids: state.offer.id
                    }}
                    onAction={onLinkChange}
                />
            </FormGroup>

            {constructorMethods.renderParams('banner')}

            {constructorMethods.renderSubMetaParams('banner')}
            {state.currentLink.selfie_link
                ? constructorMethods.renderSelfieLink()
                : null
            }

            <FormGroup
                label={t?.constructors?.resultCode || 'Result Code'}
            >
                <textarea
                    className="form-control"
                    readOnly={true}
                    value={getCode()}
                    ref={constructorMethods.resultRef}
                    style={{minHeight: 100, maxHeight: 160}}
                />
            </FormGroup>
        </CustomModal>
    );
};

ConstructorBanners.propTypes = {
    visible: PropTypes.bool,
    banner: PropTypes.object,
    offer: PropTypes.object,
    goalEntries: PropTypes.array,
    links: PropTypes.array,
    onClose: PropTypes.func
};

ConstructorBanners.defaultProps = {
    visible: false,
    banner: {},
    offer: {},
    goalEntries: [],
    links: [],
    onClose: () => {}
};

export default ConstructorBanners;